<template>
  <router-view />
</template>
<script>
export default {
  name: "MenuChildLayout",
};
</script>
